import { PASSWORD_POLICY_MESSAGE } from "../authFieldPolicy";
export const SIGNUP_UI = {
  title: "Complete Your Account Setup",
  subtitle: "Finish setting up secure access to WaterMinds.",
  submitLabel: "Accept Invite",
  submittingLabel: "Accepting invite…",
  smsConsentLabel:
    "By providing your mobile number and checking this box you consent to receiving text messages from Inframark WaterMinds. Message and data rates may apply. Reply HELP for help. Reply STOP to unsubscribe. One message per verification.",
  successMessage:
    "Your invite has been accepted. Redirecting you to sign in…",
  validatingMessage: "Validating your invitation…",
  sessionCheckMessage: "Checking your session…",
  activeSessionTitle: "Sign out required",
  activeSessionMessage:
    "You are currently signed in to WaterMinds. Sign out to continue with this invitation.",
  logoutLabel: "Sign out and continue",
  loggingOutLabel: "Signing out…",
  inviteExpiredTitle: "Invitation Expired",
  inviteExpiredMessage:
    "This invitation link has expired or is no longer valid. Please contact your administrator to request a new invitation.",
  submitErrorMessage: "Unable to accept your invite. Please try again.",
  phoneAlreadyExistsError:
    "This phone number is already in use. Try another one.",
  phoneValidateFailedError: "Failed to validate phone number. Please try again.",
  signupFields : [
    {
      name: "email",
      label: "Email",
      type: "text",
      disabled: true,
      placeholder: "Email",
    },
    {
      name: "firstName",
      label: "First Name",
      type: "text",
      required: true,
      placeholder: "Enter first name",
      validation: { maxLength: 50 },
    },
    {
      name: "lastName",
      label: "Last Name",
      type: "text",
      required: true,
      placeholder: "Enter last name",
      validation: { maxLength: 75 },
    },
    {
      name: "password",
      label: "Password",
      type: "password",
      required: true,
      placeholder: "Enter password",
      info: PASSWORD_POLICY_MESSAGE,
    },
    {
      name: "confirmPassword",
      label: "Confirm Password",
      type: "password",
      required: true,
      placeholder: "Confirm password",
      info: "Re-enter the same password.",
      showPasswordToggle: true,
    },
    {
      name: "phoneNumber",
      label: "Phone Number",
      type: "phone",
      required: true,
      country: "us",
    },
    {
      name: "acceptedTerms",
      type: "checkbox",
      label:
        "By providing your mobile number and checking this box you consent to receiving text messages from Inframark WaterMinds. Message and data rates may apply. Reply HELP for help. Reply STOP to unsubscribe. One message per verification.",
      labelFontSize: 12,
      required: true,
    },
  ]
};


